import styled from 'styled-components';
export const FlexColumn = styled.div.withConfig({
  displayName: "Flexboxes__FlexColumn",
  componentId: "sc-1oi4cwz-0"
})(["display:flex;flex-direction:column;"]);
export const FlexIconFix = styled.div.withConfig({
  displayName: "Flexboxes__FlexIconFix",
  componentId: "sc-1oi4cwz-1"
})(["display:flex;justify-content:center;align-items:center;width:24px;height:24px;"]);